<template>
  <div>
    <!-- Reporte 3 · Embudo de adquisición y conversión -->
    <exec-report-panel report-name="funnel" title="Embudo de adquisición" :filters="filters" @error="$emit('error', $event)" />
    <!-- Reporte 4 · Perfil del cliente y público principal -->
    <div class="mt-4">
      <exec-report-panel report-name="customer-profile" title="Perfil del cliente" :filters="filters" @error="$emit('error', $event)" />
    </div>
    <b-alert show variant="light" class="small mt-2">
      Recompra 30/60/90, LTV y migración se derivan de estos reportes. Métricas de
      taquizas (con_taquiza / perfil de taquizas) quedan en <strong>Fase 5</strong>.
    </b-alert>
  </div>
</template>

<script>
import ExecReportPanel from './ExecReportPanel.vue';
// Pestaña 3 · Clientes, retención y omnicanalidad (doc 04 §3, reportes 3 y 4).
export default { name: 'ExecCustomers', components: { ExecReportPanel }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
